export default __webpack_public_path__ + "static/media/Fleshstripper Boots.9b32c8bc.jpg";